import React, { Component } from 'react';
import Select from 'react-select';
import { AUTOCOMPLETE } from '../../../../../../actions/manageFeedsAction'
import AccountPicker from '../Elements/AccountPicker';
import CheckBoxField from '../Elements/CheckboxField';
import { DEBOUNCE, baseUrl } from '../../../../../../utils';


class FacebookTab extends Component {
    state = {
        handles: [],
        allAccounts: [{ ConnectedAccounts: { id: 0, value2: 'loading...' } }],
        selectValue: {},
        formatedList: [],
        allConnectAcc: []
    }

    componentDidMount() {
        this.getAccounts();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.connectedAcc) {
            if (this.state.allConnectAcc.length != nextProps.connectedAcc.length) {
                this.getAccounts();
            }
        }
    }

    getAccounts = () => {
        const { connectedAcc, onAccountChange } = this.props
        var allAccounts = []
        if (connectedAcc && connectedAcc.length > 0) {
            connectedAcc && connectedAcc.length && connectedAcc.map(acc => {
                if (acc.ConnectedAccounts.child && acc.ConnectedAccounts.child.length > 0) {
                    allAccounts = [...allAccounts, ...acc.ConnectedAccounts.child]
                }
                else {
                    this.setState({ allAccounts: [] })
                }
            })

            if (allAccounts && allAccounts.length > 0) {
                onAccountChange(allAccounts[0].ConnectedAccounts.id, allAccounts[0].ConnectedAccounts.parent);
                const formatedOption = this.formatOption(allAccounts);
                this.setState({ allAccounts, allConnectAcc: connectedAcc, formatedList: formatedOption, selectValue: formatedOption[0] });
            }
        } else {
            onAccountChange(null)
            this.setState({ allAccounts: [] })
        }
    }

    autoComplete = DEBOUNCE((value) => {
        const obj = { networkId: 3, handle: value }
            AUTOCOMPLETE(obj).then(res => {
                const { response, responseCode } = res.data;
                if (responseCode == 200) {
                    this.setState({ handles: response.data, showHandle: response.data.length > 0 })
                }
                else this.setState({ handles: [], showHandle: false })
            })
    });

    handleTextChange = value => {
        this.props.onTextChange(value);
        const isPageUrl = value.includes('https://www.facebook.com/');
       
        if (value.length > 2 && !isPageUrl) {
            this.autoComplete(value)
        } else {
            this.setState({ showHandle: false,handles:[] })
        }
    }

    onSelectHandle = (item) => {
        const { onTextChange, tab } = this.props
        onTextChange(item.link)
        document.querySelector(`#${tab}-text`).value = item.link;
        this.setState({ showHandle: false })
    }

    onAccChange = (selectedOption) => {
        const { onAccountChange } = this.props
        const { allAccounts } = this.state;
        const { value } = selectedOption;

        var parent = null;
        if (allAccounts && allAccounts.length) {
            parent = allAccounts.find(acc => acc.ConnectedAccounts.id == value);

            if (parent) {
                parent = parent.ConnectedAccounts.parent
            }
        }
        this.setState({ selectValue: selectedOption });
        onAccountChange(value, parent)
    }

    formatOption = (lists) => {
        const formatedList = lists.map((item) => ({ label: item.ConnectedAccounts.value2, value: item.ConnectedAccounts.id }));
        if (formatedList && formatedList.length > 0) {
            return [...formatedList, { label: 'other', value: 0 }];
        }
        return []
    }


    render() {
        const { tab, connectedAcc, text, albumUrl,onCheckHandler,albumUrlError, onAddAccount, album, moderation,errorMsg, onAlbumChange, connetedAccount, onConnectedAccountChange, onAlbumFieldChange, error , onTextChange} = this.props
        const { handles, showHandle, allAccounts, formatedList, selectValue } = this.state
        
        return (
            <>
                {tab == 'Page' || tab == "Albums" || tab == "hashtag"?
                    <div className="row">
                        {tab == 'Albums' ?
                            <div className="col-md-4">
                                <div className="form-group">
                                    <Select className="selectpicker selectpicker-lg" options={[{ label: 'Single Album', value: '65' }, { label: 'All Facebook Page Albums', value: '67' }]} classNamePrefix="selectpicker" defaultValue={album} onChange={(e) => onAlbumChange(e)} />
                                </div>
                            </div> : null}
                        <div className={tab == "Albums" ? "col-md-8" : "col-md-12"}>
                            <div className="form-group">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <i className={`fa fa-${tab == "hashtag" ? 'hashtag' :'flag'}`}></i>
                                        </span>
                                    </div>

                                    <input autoComplete="off" data-limit="100" placeholder={`Enter ${tab == "Page" ? "Page" : tab == "hashtag" ? "hashtag" : album.value == 67 ? 'Facebook Page':'Album'} ${tab == "Page" ? "Name" : tab == "hashtag" ? "" : 'URL'}`} value={tab == "Page" ? text : albumUrl} className="autosearch mycheck form-control" id={`${tab}-text`} onChange={(e) => tab == "Page" ? this.handleTextChange(e.target.value) :  tab == "hashtag" ? onTextChange(e.target.value) : onAlbumFieldChange(e.target.value)} type="text" />
                                    <div className="handlelist" id="" style={(showHandle && text.length > 0)? { display: "block" } : { display: "none" }}>
                                        <ul className="list-unstyled">
                                            {handles && handles.length ? handles.map((item) => (
                                                <li key={item.id} onClick={() => this.onSelectHandle(item)}>
                                                    <div className="content-section">
                                                        {item.name}
                                                        <p>{item.link}</p>
                                                    </div>
                                                </li>
                                            )) : null}
                                        </ul>
                                    </div>
                                </div>
                                {(tab == "Page" && error) || (tab == "Albums" && albumUrlError) || (tab == "hashtag" && error)  ? <span id="" className="errorMessage required">{errorMsg}</span> : null}
                            </div>
                        </div>
                    </div>
                    :
                    tab == "My Profile Posts"
                        ?
                        !(connectedAcc && connectedAcc.length > 0) ?  <div className="form-group text-center mb-6">
                        <div className="py-3">
                            <div className="btn btn-outline-gray btn-lg w-auto btn-clean d-inline-flex align-items-center btn-lg px-3" onClick={onAddAccount}>
                                <span className="symbol symbol-25 me-3">
                                    <img src={baseUrl(`social-icons/facebook.svg`)} />
                                </span>
                                <span className="text-dark-50 font-weight-bolder font-size-base">Connect Facebook</span>
                            </div>
                        </div> 
                        </div>: null
                        :
                        <div className="form-group text-center mb-6">
                            {connectedAcc && connectedAcc.length > 0 && allAccounts && allAccounts.length > 0 ?
                                <div className="col-md-12">
                                    <div className="form-group position-relative">
                                        <Select className="selectpicker selectpicker-lg" options={formatedList} classNamePrefix="selectpicker" value={selectValue} onChange={(e) => this.onAccChange(e)} />
                                    </div>
                                </div>
                                :
                                <div className="py-3">
                                    <div className="btn btn-outline-gray btn-lg w-auto btn-clean d-inline-flex align-items-center btn-lg px-3" onClick={onAddAccount}>
                                        <span className="symbol symbol-25 me-3">
                                            <img src={baseUrl(`social-icons/facebook.svg`)} />
                                        </span>
                                        <span className="text-dark-50 font-weight-bolder font-size-base">Connect Facebook</span>
                                    </div>
                                </div>
                            }
                        </div>}
                <div className="hideforBSearch">
                    <div className="checkbox-inline">
                        <CheckBoxField isChecked={moderation} onChangeHandler={(e) => onCheckHandler(e)} name={"moderation"} id={`checkbox_${tab.replace(/\s/g,'')}`} />
                    </div>
                </div>
                {connectedAcc && connectedAcc.length && !["Page Reviews", "Page Mentions"].includes(tab) ? <AccountPicker connectedAcc={connectedAcc} networkId={'3'} onConnectedAccountChange={onConnectedAccountChange} connetedAccount={connetedAccount} /> : null}
            </>
        )
    }
}

export default FacebookTab;
